import React from "react";
import Typography from "@material-ui/core/Typography";
import {inventarioResources} from "../endpoints";
import MaterialTable from "material-table";
import tableicons from "../tableicons";
import SearchIcon from "@material-ui/icons/Search";
import {withRouter} from "react-router";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import DialogRestaurarConteoEliminado from "../components/DialogRestaurarConteoEliminado";
import SnackbarAlert from "../components/SnackbarAlert";
import useToken from "../useToken";

class Eliminados extends React.Component{
    constructor(props) {
        let datos_inv = useToken.getDatos()
        super(props);
        this.state={
            eliminados:[],
            selectedRow:null,
            restaurar:false,
            penSnack:false,
            severity: null,
            message:null,
            datos:null,
            openSnack:false,
            titulo_columna : (datos_inv.app === 'sodimac'? 'Costo':'Importe'),
        }
    }

    conteos_eliminados = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        inventarioResources.conteosEliminados().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({eliminados:result.eliminados})
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    handleClose = () =>{
        this.setState({restaurar:false})
    }


    refrescar = (estado,severity) =>{
        this.setState({restaurar:false, openSnack:false, severity: null, message:null})
        this.setState({openSnack:true, severity:severity, message:estado})
        if(severity === "success"){
            this.conteos_eliminados()
        }
    }

    componentDidMount() {
        this.conteos_eliminados()
    }

    verDetalles = (rowData) =>{
        this.props.history.push("/detalle_eliminados/"+ rowData.tag)
    }

    paraRestaurar = (row) =>{
        this.setState({restaurar:true, datos:row})
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Eliminados
                </Typography>

                <MaterialTable
                    title=" "
                    icons={tableicons}
                    columns={[
                        { title: 'Tag', field: 'tag' },
                        { title: 'Eliminados', field: 'eliminados'},
                        { title: this.state.titulo_columna, field: 'importe'},
                    ]}
                    data={this.state.eliminados}
                    actions={[
                        {
                            icon:  () => <SearchIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Ver detalle',
                            onClick: (event, rowData) => this.verDetalles(rowData),
                            position:"row"
                        },
                        rowData => ({
                            icon:  () =><RestoreFromTrashIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Reestablecer conteos eliminado',
                            onClick: (event, rowData) => this.paraRestaurar(rowData),
                            hidden: rowData.eliminado === false}),
                    ]}
                    options={{
                        pageSize: 25,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar'
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                />
                {this.state.restaurar ? <DialogRestaurarConteoEliminado title={"Restaurar conteos eliminado del tag " + this.state.datos.tag}  recuperar={"tag"} conteo={this.state.datos.tag} refrescar={this.refrescar} handleClose={this.handleClose}/>: null}

                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default withRouter(Eliminados);